export const DESKTOP_WIN_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_tubmix-studio/artifacts/nxuavdzr_MonInge_Setup-4%20%281%29.exe";

export const HERO_IMAGE_URL =
  "https://images.unsplash.com/photo-1526218626217-dc65a29bb444?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
